import type { ProgramUserRsvp } from 'models';
import { useCallback } from 'react';
import { Icon } from 'ui';

export const useGetInviteesBadgeIcon = () =>
  useCallback(({ rsvp }: { rsvp: ProgramUserRsvp }) => {
    switch (rsvp) {
      case 'going':
        return (
          <Icon
            backgroundColor="white"
            color="success"
            icon="check-circle-fill"
            shape="circle"
            size="extra-extra-small"
          />
        );
      case 'not_going':
        return (
          <Icon
            backgroundColor="white"
            color="error"
            icon="close-circle-fill"
            shape="circle"
            size="extra-extra-small"
          />
        );
      case 'pending':
        return (
          <Icon backgroundColor="white" color="secondary" icon="time-fill" shape="circle" size="extra-extra-small" />
        );
    }
  }, []);
